export const appRoutes = {
    root: '/',
    home: '/home',
    aboutUs: '/about-us',
    services: '/services',
    products: '/products',
    contactUs: '/contact-us',
    // Account
    account: '/account',
    login: '/account/login',
    register: '/account/register',
    logout: '/account/logout',
    unauthorized: '/account/unauthorized',
    // Admin
    admin: '/admin',
    dashboard: '/admin/dashboard',
    // Admin/Users
    users: '/admin/users',
    userAdd: '/admin/user',
    userEdit: '/admin/user/:id/edit',
    userView: '/admin/user/:id/view',
    // Admin/Customers
    customers: '/admin/customers',
    customerAdd: '/admin/customer',
    customerEdit: '/admin/customer/:id/edit',
    customerView: '/admin/customer/:id/view',
    customerInvoices: `/admin/customer/:id/invoices`,
    customerInvoiceAdd: `/admin/customer/:id/invoice`,
    customerInvoiceItems: `/admin/customer/:id/invoiceitems`,
    // Admin/Invoices
    invoices: `/admin/invoices`,
    invoicedetails: `/admin/invoice/:id/details`,
}
